import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';
var badgeStyle = createRuntimeFn({
  defaultClassName: 'style__miz1sa3 style__miz1sa2',
  variantClassNames: {
    simple: {
      small: 'style_simple_small__miz1sa5',
      medium: 'style_simple_medium__miz1sa6'
    },
    contents: {
      small: 'style_contents_small__miz1sa7',
      medium: 'style_contents_medium__miz1sa8'
    },
    icon: {
      small: 'style_icon_small__miz1sa9'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var vars = {
  color: 'var(--miz1sa0)',
  backgroundColor: 'var(--miz1sa1)'
};
export { badgeStyle, vars };
